export const MSGS = {
  GEO_FENCE_ADD_SUCCESS: "Geofence added successfully",
  GEO_FENCE__UPDATE_SUCCESS: "Geofence updated successfully",
};

export default MSGS;
